import initialState from './initialState';
import * as types from '../actions/actionTypes';

export default function auth(state = initialState, action) {
  switch (action.type) {
    case types.LOG_IN:
      return Object.assign({}, state, {
        uid: action.payload.uid,
        mid: action.payload.mid,
        username: action.payload.username,
        email: action.payload.email,
        receive_email: action.payload.receive_email,
        has_password: action.payload.has_password,
        is_admin: action.payload.is_admin,
        role: action.payload.role,
        timestamp: action.payload.timestamp,
        picture: action.payload.picture,
        designee1: action.payload.designee1,
        relationship1: action.payload.relationship1,
        designee2: action.payload.designee2,
        relationship2: action.payload.relationship2,
        designee3: action.payload.designee3,
        relationship3: action.payload.relationship3,
        do_not_disclose: action.payload.do_not_disclose,
        authenticity_token: action.payload.authenticity_token,
        loginInProgress: action.payload.loginInProgress,
        facebook_access_token: action.payload.facebook_access_token,
        instagram_access_token: action.payload.instagram_access_token,
        twitter_access_token: action.payload.twitter_access_token,
        twitter_access_secret: action.payload.twitter_access_secret,
        twitter_access_props: action.payload.twitter_access_props,
        redirect: action.payload.redirect,
      });
    case types.LOG_OUT:
      return {};
    case types.SET_FAILED_LOGIN:
      return Object.assign({}, state, {
        failedLogin: action.payload.failedLogin,
        failedLoginMessage: action.payload.failedLoginMessage,
        loginInProgress: false,
      });
    case types.CLEAR_FAILED_LOGIN:
      return Object.assign({}, state, {
        failedLogin: '',
        failedLoginMessage: '',
        loginInProgress: false,
      });
    case types.WAIT_FOR_LOGIN:
      return Object.assign({}, state, {
        loginInProgress: true,
      });
    case types.EMPTY_SESSION_COOKIE:
      return Object.assign({}, state, {
        failedLogin: true,
        loginInProgress: false,
      });
    case types.UPDATE_EMAIL:
      return Object.assign({}, state, {
        email: action.payload,
      });
    case types.UPDATE_RECEIVE_EMAIL:
      return Object.assign({}, state, {
        receive_email: action.payload,
      });
    case types.RESET_PASSWORD:
      return Object.assign({}, state, {
        resetPasswordState: action.payload,
      });
    case types.SET_PASSWORD:
      return Object.assign({}, state, {
        has_password: true,
      });
    case types.SET_FACEBOOK_ACCESS_TOKEN:
      return Object.assign({}, state, {
        facebook_access_token: action.payload,
      })
    case types.SET_INSTAGRAM_ACCESS_TOKEN:
      return Object.assign({}, state, {
        instagram_access_token: action.payload,
      })
    case types.SET_TWITTER_ACCESS_TOKEN:
      return Object.assign({}, state, {
        twitter_access_token: action.payload,
      })
    case types.SET_TWITTER_ACCESS_SECRET:
      return Object.assign({}, state, {
        twitter_access_secret: action.payload,
      })
    case types.SET_TWITTER_ACCESS_PROPS:
      return Object.assign({}, state, {
        twitter_access_props: action.payload,
      })
    default:
      return state;
  }
}
